module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#trending",
      toString: function () {
        return this.url;
      }
    }